var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTelegram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 11,
  viewBox: "0 0 13 11"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "$",
  fill: "#262626",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m13 .39-2.056 10.152s-.288.704-1.078.366L5.12 7.346l-1.725-.817L.49 5.572s-.445-.155-.489-.493.504-.521.504-.521L12.05.122S13-.286 13 .39"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.292 10s-.132-.012-.295-.525C3.833 8.962 3 6.26 3 6.26l6.62-4.159s.383-.23.37 0c0 0 .067.04-.137.23-.205.189-5.201 4.631-5.201 4.631"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 8.336 5.281 9.94s-.134.104-.281.038L5.33 7"
}))));
export default SvgTelegram;